import { Controller } from '@hotwired/stimulus';
import {fadeOut} from "../helpers";

export default class extends Controller {
  connect() {
    this.popup  = this.element;
  }

  close() {
    fadeOut(this.popup);
  }
}
